module.exports = "<p-overlayPanel \r\n    #toggleOverlay \r\n    [style]=\"{'width': '250px'}\" \r\n    [dismissable]=\"true\" \r\n    [showCloseIcon]=\"false\"\r\n> \r\n  Select Dashboard:\r\n<p-listbox [options]=\"dashboards\" (onChange)=\"onDashboardChange($event)\"  [style]=\"{'width': '100%'}\"    ></p-listbox>\r\n\r\n</p-overlayPanel>"


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/src/app/features/dashboard/toggle-dashboard/toggle-dashboard.component.html
// module id = ../../../../../src/app/features/dashboard/toggle-dashboard/toggle-dashboard.component.html
// module chunks = main